import { pathnameToLanguage } from 'docs/src/modules/utils/helpers';
// This is a fallback logic to define the productId and productCategoryId of the page.
// Markdown pages can override this value when the URL patterns they follow are a bit strange,
// which should stay the rare exception.
export default function getProductInfoFromUrl(asPath) {
  var asPathWithoutLang = pathnameToLanguage(asPath).canonicalAsServer;
  var firstFolder = asPathWithoutLang.replace(/^\/+([^/]+)\/.*/, '$1');

  // When serialized undefined/null are the same, so we encode null as 'null' to be
  // able to differentiate when the value isn't set vs. set to the right null value.
  var productCategoryId = 'null';
  var productId = 'null';
  if (firstFolder === 'material-ui' || firstFolder === 'joy-ui' || firstFolder === 'base-ui' || firstFolder === 'system') {
    productCategoryId = 'core';
    productId = firstFolder;
  }
  if (firstFolder === 'x') {
    productCategoryId = 'x';
    productId = "x-".concat(asPathWithoutLang.replace('/x/react-', '').replace(/\/.*/, ''));

    // No match, give up on it.
    if (productId === 'x-') {
      productId = 'null';
    }
  }
  if (firstFolder === 'toolpad') {
    productCategoryId = 'toolpad';
    var secondFolder = asPathWithoutLang.replace(/^\/+[^/]+\/([^/]+)\/.*/, '$1');
    if (secondFolder === 'studio') {
      productId = 'toolpad-studio';
    } else {
      productId = 'toolpad-core';
    }
  }
  if (firstFolder === 'docs') {
    productId = firstFolder;
  }

  // TODO remove, legacy
  if (firstFolder === 'versions' || firstFolder === 'production-error') {
    productId = 'docs';
  }
  if (asPathWithoutLang.startsWith('/experiments/docs/')) {
    productId = 'docs-infra';
  }
  return {
    productCategoryId: productCategoryId,
    productId: productId
  };
}